import RestrictionDialog from '@/components/restrictions/RestrictionDialog.vue'
import { useDialog } from '@/core/composables/useDialog'
import { computedAsync } from '@vueuse/core'
import invariant from 'invariant'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export const useRestrictions = (callback: UseRestrictionsCallback) => {
  const { showDialog } = useDialog()
  const { locale } = useI18n()

  const restrictionStatus = computedAsync(
    () =>
      callback({
        language: locale.value as Locale
      }),
    undefined,
    {
      onError: console.error
    }
  )

  const hasRestrictions = computed(
    () => restrictionStatus.value?.status === false
  )

  const restrictions = computed(() => restrictionStatus.value?.restrictions)

  const showRestrictionDialog = ({ title }: { title: string }) => {
    invariant(hasRestrictions.value, 'Restrictions are required')
    return showDialog({
      component: RestrictionDialog,
      props: {
        restrictions,
        title
      }
    })
  }

  return {
    showRestrictionDialog,
    restrictions,
    hasRestrictions
  }
}
